// opervex-frontend/src/pages/Accounting/Branch.js

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Form, InputGroup, Card, Button } from "react-bootstrap";
import { FaSearch, FaPlus, FaSave, FaPencilAlt } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import MaskedFormControl from "react-bootstrap-maskedinput";

import { useAuth } from "../../contexts/AuthContext";
import { SearchHelpModal } from "../../utils/SearchHelp";
import useOpervex from "../../hooks/useOpervex";
import ConfirmService from "../../components/ConfirmationModal/ConfirmService";

const rolePageRequire = "BRANCH";

var dataDefault = {
  id: "",
  description: "",
  cnpj: "",
  resale: false,
  disabled: false,
};

const actionsDefault = {
  create: true,
  change: true,
  delete: true,
  save: true,
};

const Branch = () => {
  const { roles, loadingGlobal } = useAuth();
  const [disabledField, setDisabledField] = useState(true);
  const [actions, setActions] = useState(actionsDefault);
  const [data, setData] = useState(dataDefault);
  const { id } = useParams();
  const OpervexAPI = useOpervex();

  useEffect(() => {
    const fetchData = async () => {
      commandAction({ ...actionsDefault, create: false });

      if (id) {
        await searchAPI(id);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loadingGlobal) {
    return <div>Carregando...</div>;
  }

  const commandAction = (actions) => {
    const hasPermission = roles.find((role) => role.command === rolePageRequire);

    if (!hasPermission) {
      setActions(actionsDefault);
      return;
    }

    if (!actions.create) actions.create = !hasPermission.actions.some((action) => action.key === "Create");
    if (!actions.change) actions.change = !hasPermission.actions.some((action) => action.key === "Change");

    setActions({ ...actions });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    var newData = { ...data, [name]: type === "checkbox" ? checked : value };

    setData(newData);
  };

  // CRUD Handlers
  const handleButtonCreate = () => {
    setData(dataDefault);
    commandAction({ ...actionsDefault, save: false });
    setDisabledField(false);
  };

  const handleButtonCancel = () => {
    if (data.id === "") {
      setData(dataDefault);
      setDisabledField(true);
      commandAction({ ...actionsDefault, create: false });
    } else {
      searchAPI(data.id);
    }
  };

  const handleButtonSave = async () => {
    var body = { ...data };

    body.cnpj = body.cnpj.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");

    if (data.id) {
      const result = await OpervexAPI.Accounting.Branches.update(body.id, body);
      if (result.errors) {
        await ConfirmService.show("Aviso", result.errors, true);
        return;
      }

      await searchAPI(data.id);

      alert("Empresa/Filial atualizada com sucesso!");
    } else {
      const result = await OpervexAPI.Accounting.Branches.create(body);
      if (result.errors) {
        await ConfirmService.show("Aviso", result.errors, true);
        return;
      }

      await searchAPI(result.id);

      alert("Empresa/Filial criada com sucesso!");
    }
  };

  const handleButtonSearch = async () => {
    const item = await SearchHelpModal({
      urlData: "/Accounting/Branches/SearchHelp",
      schema: await OpervexAPI.Accounting.Branches.schema(),
    });

    if (item && item.id) await searchAPI(item.id);
  };

  const handleButtonChange = async () => {
    setDisabledField(false);
    commandAction({ ...actionsDefault, save: false });
  };

  const searchAPI = async (id) => {
    setDisabledField(true);

    if (!id) return;

    var result = await OpervexAPI.Accounting.Branches.findId(id);

    if (result && !result.error) {
      setData(result);
      commandAction({ ...actionsDefault, create: false, change: false });
    } else {
      setData(dataDefault);
      commandAction({ ...actionsDefault, create: false });
      alert(result.error);
    }
  };

  return (
    <>
      <Container className="mt-2">
        <Form>
          {/* ----- Header / Additional -----*/}
          <Card className="mb-2">
            <Card.Header>
              <Row className="d-flex justify-content-between">
                <Col md={8}>
                  <h5>Cabeçalho</h5>
                </Col>
                <Col md={4} className="text-end">
                  <Button variant="success" size="sm" className="me-2" onClick={handleButtonCreate} hidden={actions.create}>
                    <FaPlus /> Novo
                  </Button>
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonChange} hidden={actions.change}>
                    <FaPencilAlt /> Alterar
                  </Button>
                  <Button variant="danger" size="sm" className="me-2" onClick={handleButtonCancel} hidden={actions.save}>
                    <MdOutlineCancel /> Cancelar
                  </Button>
                  <Button variant="primary" size="sm" className="me-2" onClick={handleButtonSave} hidden={actions.save}>
                    <FaSave /> Salvar
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={2}>
                  <Form.Group>
                    <Form.Label>Código</Form.Label>
                    <InputGroup>
                      <Form.Control type="text" size="sm" value={data.id} name="id" onChange={handleChange} disabled={true} />

                      <InputGroup.Text size="sm" type="button" onClick={handleButtonSearch}>
                        <FaSearch />
                      </InputGroup.Text>
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group>
                    <Form.Label>Descrição</Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      name="description"
                      value={data.description}
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>

                <Col md={2} className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    id="disabled"
                    checked={data.disabled}
                    name="disabled"
                    onChange={handleChange}
                    label="Inativo"
                    disabled={disabledField}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
          {/* ----- Additional -----*/}
          <Card className="mb-2">
            <Card.Header>
              <h5>Informações Adicionais</h5>
            </Card.Header>
            <Card.Body>
              <Row className="mb-2">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>CNPJ</Form.Label>
                    <MaskedFormControl
                      type="text"
                      size="sm"
                      mask="11.111.111/1111-11"
                      name="cnpj"
                      value={data.cnpj} // Make sure to include this
                      onChange={handleChange}
                      disabled={disabledField}
                    />
                  </Form.Group>
                </Col>
                <Col md={2} className="d-flex align-items-center">
                  <Form.Check
                    type="checkbox"
                    id="resale"
                    checked={data.resale}
                    name="resale"
                    onChange={handleChange}
                    label="Revenda"
                    disabled={disabledField}
                  />
                </Col>
                <Col md={4}></Col>
              </Row>
            </Card.Body>
          </Card>
        </Form>
      </Container>
    </>
  );
};

export default Branch;
